import { Axios } from "./request";

const API_URL = "usersapi/v1/filter/";

export const FILTER_API = {
  GetFilterDataCollection: (isDemandsInformations, body) => {
    return Axios.post(
      `${API_URL}GetFilterDataCollection?isDemandsInformations=${isDemandsInformations}`,
      body
    );
  },
};
